import styled from "styled-components";

export const MaxWidthContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;
